/**
 * Builder Auth configuration
 * Server-side env vars for API routes + client-side endpoint paths
 */
export const authConfig = {
  // Server-side only (used in API routes)
  authBaseUrl: import.meta.env.VITE_AUTH_API_URL || "http://localhost:8787",
  tenantId: import.meta.env.VITE_TENANT_ID || "",
  identityMode:
    import.meta.env.VITE_AUTH_IDENTIFIER_MODE === "username" ? "username" : "email",
  // BUILDER_AUTH_API_KEY is server-side only (S2S calls). Worker reads it
  // via env binding; FE bundle never sees the secret.
  authApiKey: "",

  // Client-side API endpoints (relative — go through Next.js proxy)
  endpoints: {
    login: "/api/auth/login",
    refresh: "/api/auth/refresh",
    logout: "/api/auth/logout",
    me: "/api/auth/me",
    register: "/api/auth/register",
    signupWithInvite: "/api/auth/signup-with-invite",
    verifyEmail: "/api/auth/verify-email",
    forgotPassword: "/api/auth/forgot-password",
    resetPassword: "/api/auth/reset-password",
    changePassword: "/api/auth/change-password",
    usersBatch: "/api/auth/users-batch",
    usersSearch: "/api/auth/users-search",
  },
} as const;

export type AuthConfig = typeof authConfig;
export type AuthIdentifierMode = typeof authConfig.identityMode;
export const isUsernameAuthMode = authConfig.identityMode === "username";
